import { render, staticRenderFns } from "./section_setup.vue?vue&type=template&id=5a1cf56e&"
import script from "./section_setup.vue?vue&type=script&lang=js&"
export * from "./section_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports